import api, { handleApiError, fetchAllDataRest } from './client';

export const documentService = {
  getUserDocuments: async (userId, categoryFilter = 'all', documentTypeFilter = '', page = 1, limit = 5, exportAll = false) => {
    try {
      const params = {
        categoryFilter: categoryFilter === 'all' ? undefined : categoryFilter,
        documentTypeFilter: documentTypeFilter || undefined,
        page,
        limit,
      };

      const url = `/api/documents/user/${userId}`;

      if (exportAll) {
        const result = await fetchAllDataRest(url, params, 'documenti utente');
        if (result.success) {
          const items = result.data?.items || result.data || [];
          return {
            success: true,
            data: items,
            pagination: {
              totalCount: result.data?.totalCount ?? items.length,
              totalPages: 1,
              currentPage: 1,
            },
          };
        }
        return { success: false, error: result.message };
      }

      const response = await api.get(url, { params });
      const data = response.data;
      if (!data) {
        return { success: false, error: 'Nessun dato ricevuto dal server' };
      }

      return {
        success: true,
        data: data.items || [],
        pagination: {
          totalCount: data.totalCount || 0,
          totalPages: data.totalPages || 1,
          currentPage: data.currentPage || 1,
        },
      };
    } catch (error) {
      console.error('Error fetching user documents:', error);
      return {
        success: false,
        error: error.response?.data?.message || "Errore nel caricamento dei documenti dell'utente",
      };
    }
  },

  createDocument: async (documentData) => {
    try {
      const payload = {
        relatedUser: documentData.relatedUser,
        title: documentData.title,
        description: documentData.description || null,
        documentType: documentData.documentType || null,
        category: documentData.category,
        fileName: documentData.fileName || '',
        filePath: documentData.filePath || '',
        fileSize: documentData.fileSize || 0,
        fileType: documentData.fileType || '',
      };

      const response = await api.post('/api/documents', payload);
      return {
        success: true,
        data: response.data,
        message: 'Documento creato con successo',
      };
    } catch (error) {
      console.error('Create document error:', error);
      return handleApiError(error, 'Errore nella creazione del documento');
    }
  },

  createDocumentWithFile: async (documentData) => {
    try {
      const formData = new FormData();
      formData.append('title', documentData.title);
      formData.append('description', documentData.description || '');
      formData.append('documentType', documentData.documentType || '');
      formData.append('category', documentData.category);
      formData.append('userId', documentData.userId || documentData.relatedUser);

      if (documentData.file) {
        formData.append('file', documentData.file);
      }

      const response = await api.post('/api/documents', formData);
      return {
        success: true,
        data: response.data,
        message: 'Documento caricato con successo',
      };
    } catch (error) {
      console.error('Create document error:', error);
      return handleApiError(error, 'Errore nel caricamento del documento');
    }
  },

  updateDocument: async (id, documentData) => {
    try {
      const payload = {
        title: documentData.title,
        description: documentData.description || null,
        documentType: documentData.documentType,
        category: documentData.category,
      };

      const response = await api.put(`/api/documents/${id}`, payload);
      return {
        success: true,
        data: response.data,
        message: 'Documento aggiornato con successo',
      };
    } catch (error) {
      console.error('Update document error:', error);
      return handleApiError(error, "Errore nell'aggiornamento del documento");
    }
  },

  deleteDocument: async (id) => {
    try {
      const response = await api.delete(`/api/documents/${id}`);
      return {
        success: response.data?.success ?? true,
        message: 'Documento eliminato con successo',
      };
    } catch (error) {
      console.error('Delete document error:', error);
      return handleApiError(error, "Errore nell'eliminazione del documento");
    }
  },

  deleteFileDocument: async (id) => {
    try {
      const response = await api.delete(`/api/documents/${id}/file`);
      return {
        success: response.data?.success ?? true,
        message: 'File documento eliminato con successo',
      };
    } catch (error) {
      console.error('Delete document error:', error);
      return handleApiError(error, "Errore nell'eliminazione del file");
    }
  },

  downloadDocument: async (id) => {
    try {
      const response = await api.get(`/api/File/document/${id}/download`, {
        responseType: 'blob',
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Download document error:', error);
      return {
        success: false,
        message: 'Errore nel download del documento',
      };
    }
  },

  downloadDocumentFile: async (document) => {
    try {
      const response = await api.get(`/api/File/document/${document.id}/download`, {
        responseType: 'blob',
      });

      if (response.status === 200) {
        const blob = response.data;
        const url = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        a.href = url;
        a.download = document.fileName || 'documento';
        window.document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        window.document.body.removeChild(a);

        return { success: true };
      }
      return { success: false, message: 'Errore durante il download del file' };
    } catch (error) {
      console.error('Download document file error:', error);
      return {
        success: false,
        message: 'Errore di connessione durante il download',
      };
    }
  },
};

export default documentService;
